export const ROW_HEIGHT = 3; // 每一行的高度，單位為rem

export const TIME_SNAP_INTERVAL = 15; // 透過拖移可修改的最小時間間隔為15分鐘。若需調整此數值，請注意其他相依功能可能需要同步修改

export const MAX_MINUTES_IN_DAY = 1439;

export const TOTAL_WIDTH_RATIO = 0.95;

export const MIN_WIDTH = TOTAL_WIDTH_RATIO * 0.18;

export const WEEKDAY_LABELS = [
  '週一',
  '週二',
  '週三',
  '週四',
  '週五',
  '週六',
  '週日',
];

// 警告：修改此時間範圍時，需同步更新處理時間邊界(03:00-23:00)的相關函數
export const TIME_SLOTS = [
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
];

export const MIN_DURATION = 30;
export const TIME_THRESHOLD = 30;

export const GROUP_UNDERLYING_BLOCK_OFFSET_RATIO = 0.03;

export const BASE_OFFSET_RATIO = 0.025;
export const ADDITIONAL_OFFSET_RATIO = 0.015;
export const LAYER_SEPARATION_BONUS = 0.04;
export const MULTI_BLOCK_LAYOUT_CONFIG = {
  2: [
    { width: 0.65, offset: 0 },
    { width: 0.6, offset: 0.4 },
  ],
  3: [
    { width: 0.55, offset: 0 },
    { width: 0.55, offset: 0.3 },
    { width: 0.45, offset: 0.55 },
  ],
  4: [
    { width: 0.45, offset: 0 },
    { width: 0.45, offset: 0.25 },
    { width: 0.45, offset: 0.45 },
    { width: 0.35, offset: 0.65 },
  ],
};

export const MULTI_BLOCK_FALLBACK_BASE_WIDTH_RATIO = 0.35;
export const MULTI_BLOCK_FALLBACK_OFFSET_START = 0.2;
export const MULTI_BLOCK_FALLBACK_OFFSET_STEP = 0.15;
